import BaseService from '@/ecm/common/BaseService.js';
import Utils from '@/ecm/common/Utils.js';

class BasketService {
  baseUrl = 'basket';

  getGrid = () => Utils.grid.getParameters(`${this.baseUrl}/get-grid`);
  activate = (id) => BaseService.put({ url: `${this.baseUrl}/activate/${id}` });
  delete = (id) => BaseService.delete({ url: `${this.baseUrl}/${id}` });
  save = (user) => BaseService.post({ url: `${this.baseUrl}/save`, data: user });
  getDocumentCount = (dashboardItemDTO) => BaseService.post({ url: `${this.baseUrl}/get-document-count`, data: dashboardItemDTO });
  saveGroupSettingsForBasket = (groupSettings) => BaseService.post({ url: `${this.baseUrl}/basket-group-settings`, data: groupSettings });
  getGroupSettingsForBasket = (basketId) => BaseService.get({ url: `${this.baseUrl}/${basketId}/group-settings` });
  get = (id) => BaseService.get({ url: `${this.baseUrl}/${id}` });
  getAvailableContentTypes = (id, includeAllVersions = false) => {
    const params = new URLSearchParams(
        Object.entries({ id, includeAllVersions }).filter(([, value]) => value != null)
      ).toString();

      return BaseService.get({ url: `${this.baseUrl}/available-content-types?${params}` });
  };
}

export default new BasketService();
